"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreActions = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moreActionsModule = _interopRequireDefault(require("./more-actions.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Paper = require("../../elements/paper/Paper");
var _Option = require("../../elements/option/Option");
var _menuButton = require("@reach/menu-button");
var _popover = require("@reach/popover");
var _Button = require("../../elements/button/Button");
var _moreVertical = require("../../assets/icons/more-vertical.svg");
var MoreActions = function MoreActions(_ref) {
  var options = _ref.options,
    onOptionClick = _ref.onOptionClick,
    className = _ref.className,
    testId = _ref['data-testid'],
    onClick = _ref.onClick;
  var buttonRef = (0, _react.useRef)(null);
  var getPopoverPosition = (0, _react.useCallback)(function (_, popoverRect) {
    var _buttonRef$current;
    var buttonRect = (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.getBoundingClientRect();
    /* istanbul ignore if */
    if (!buttonRect || !popoverRect) {
      return {};
    }
    var _getCollisions = (0, _popover.getCollisions)(buttonRect, popoverRect),
      directionUp = _getCollisions.directionUp,
      directionLeft = _getCollisions.directionLeft;
    return {
      left: directionLeft ? "".concat(buttonRect.left + window.pageXOffset, "px") : "".concat(buttonRect.right - popoverRect.width + window.pageXOffset, "px"),
      top: directionUp ? "".concat(buttonRect.top - popoverRect.height + window.pageYOffset, "px") : "".concat(buttonRect.top + buttonRect.height + window.pageYOffset, "px")
    };
  }, [buttonRef]);
  return /*#__PURE__*/_react.default.createElement(_menuButton.Menu, {
    as: 'div',
    className: (0, _classnames.default)(_moreActionsModule.default['more-actions'], className),
    "data-testid": testId || 'menu'
  }, /*#__PURE__*/_react.default.createElement(_menuButton.MenuButton, {
    "data-testid": "list-trigger",
    className: _moreActionsModule.default['more-actions__list-trigger'],
    "aria-label": "chevron",
    as: _Button.Button,
    level: "neutral-borderless",
    innerRef: buttonRef,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_moreVertical.ReactComponent, null)), /*#__PURE__*/_react.default.createElement(_menuButton.MenuPopover, {
    position: getPopoverPosition
  }, /*#__PURE__*/_react.default.createElement(_menuButton.MenuItems, {
    as: _Paper.Paper,
    className: _moreActionsModule.default['more-actions__list']
  }, options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_menuButton.MenuItem, {
      "data-testid": o.testId,
      as: _Option.Option,
      value: o.value,
      key: o.value,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      onSelect: function onSelect() {
        return onOptionClick(o.value);
      }
    }, o.label);
  }))));
};
exports.MoreActions = MoreActions;